import React from 'react';
import RetirementCalculator from './components/retirement-calculator';

function App() {
  return (
    <div className="App">
      <RetirementCalculator />
    </div>
  );
}

export default App;
